var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEllipse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 210,
    viewBox: "0 0 210 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180.299 175.133C181.033 175.817 181.075 176.968 180.378 177.69C162.069 196.678 137.247 208.073 110.866 209.553C83.8808 211.068 57.3548 202.089 36.8366 184.496C16.3183 166.903 3.39714 142.058 0.775607 115.157C-1.84593 88.2562 6.03524 61.3837 22.7707 40.1601C39.5061 18.9364 63.7996 5.00553 90.5699 1.28114C117.34 -2.44325 144.514 4.32736 166.407 20.1768C188.3 36.0263 203.217 59.727 208.038 86.3216C212.751 112.32 207.459 139.115 193.265 161.348C192.725 162.193 191.596 162.421 190.76 161.867C189.924 161.312 189.697 160.186 190.236 159.34C203.912 137.889 209.009 112.045 204.463 86.9697C199.81 61.2977 185.41 38.4194 164.276 23.1198C143.143 7.82025 116.912 1.28456 91.0705 4.87973C65.2291 8.4749 41.7785 21.9225 25.6237 42.4097C9.46887 62.897 1.86114 88.8371 4.39173 114.804C6.9223 140.772 19.3952 164.755 39.2015 181.738C59.0079 198.721 84.6136 207.388 110.663 205.926C136.107 204.498 160.049 193.515 177.719 175.214C178.416 174.492 179.565 174.449 180.299 175.133Z",
    fill: "url(#paint0_linear_63_4139)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_63_4139",
    x1: 137.479,
    y1: -15.6204,
    x2: 19.0004,
    y2: 202.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C93B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C93B3B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse);
export default __webpack_public_path__ + "static/media/ellipse.94e7f1d29726a98cf0319675f7612ff9.svg";
export { ForwardRef as ReactComponent };